import clsx from "clsx";
import React from "react";

export const Input = ({ label, rightIcon, errorMessage, error, ...rest }) => {
  return (
    <div className="flex w-full flex-col items-start my-3">
      <div
        className={clsx(
          "flex w-full flex-1 items-center px-3 py-3 border rounded-lg border-blue-100  focus-within:border-textGray relative group",
          rest.disabled && "bg-gray-50",
          !rest.disabled && "hover:border-textGray"
        )}
      >
        <div
          className={clsx(
            "invisible group-focus-within:visible absolute bottom-9 px-2 left-2 bg-white text-textGray",
            !!rest.value &&
              rest.value !== "" &&
              rest.disabled &&
              "bg-slate-200 rounded-lg"
          )}
          style={{ visibility: !!rest.value && rest.value !== "" && "visible" }}
        >
          {label}
        </div>
        <input
          className={clsx(
            "w-full max-w-full border-none outline-none focus:placeholder:invisible flex flex-1",
            rest.disabled && "bg-gray-50"
          )}
          placeholder={label}
          {...rest}
        />
        {!!rightIcon && <div className="pl-1.5">{rightIcon}</div>}
      </div>
      {!!error && (
        <div className="text-sm text-red-500 pl-1">{errorMessage}</div>
      )}
    </div>
  );
};
